import { render, staticRenderFns } from "./AuthBox.vue?vue&type=template&id=388767c4"
import script from "./AuthBox.vue?vue&type=script&lang=js"
export * from "./AuthBox.vue?vue&type=script&lang=js"
import style0 from "./AuthBox.vue?vue&type=style&index=0&id=388767c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports